import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import {
  createSearch,
  getSearchById,
} from '../../../../../shared/api/magellan/vaultSearch';
import type { CreateVaultSearchRequestDTO } from '../../../../../shared/api/magellan/vaultSearch/dto';

export function useGetVaultSearchByIdQuery(searchId: number) {
  return useSuspenseQuery({
    queryKey: [getSearchById.name, searchId],
    queryFn: () => getSearchById({ searchId }),
  });
}

interface UseCreateVaultSearchMutationOptions {
  onSuccess?: (searchId: number) => void;
}

export function useCreateVaultSearchMutation(
  options?: UseCreateVaultSearchMutationOptions,
) {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (payload: CreateVaultSearchRequestDTO) => createSearch(payload),
    onSuccess: ({ id }) => {
      navigate(`/response/search/${id}`);
      options?.onSuccess?.(id);
    },
  });
}
